import script from "./giftCodeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./giftCodeView.vue?vue&type=script&setup=true&lang=ts"

import "./giftCodeView.vue?vue&type=style&index=0&id=33c7fcfd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33c7fcfd"]])

export default __exports__